import { stringify } from './stringify';

export function toString(value: any, verbose = false): string {
    switch (typeof value) {
        case 'boolean':
            return value ? 'true' : 'false';
        case 'string':
            return value;
        case 'function':
            return '[Function]';
        case 'object':
            if (value !== null) {
                return stringify(value);
            }
            return verbose ? 'null' : '';
        case 'undefined':
            return verbose ? 'undefined' : '';
        case 'number':
            return `${value}`;
        default:
            return '';
    }
}
